export default __webpack_public_path__ + "static/media/copy.109f1e0b.svg";